export default "__VITE_ASSET__D4ywTgvL__"